import DOMUtils from "@utils/dom.utils";

export default {
  props: {
    context: { type: String, required: true },
  },
  data() {
    return {
      truncated: [],
    };
  },
  computed: {
    isSummaryMode() {
      return this.context === "card";
    },
    showTruncate() {
      return (index) => {
        return this.truncated[index];
      };
    },
    resourceTaggingSummaryTruncate() {
      if (this.resourceTaggingSummary.length <= 2) {
        return this.resourceTaggingSummary;
      }
      return [this.resourceTaggingSummary[0], "..."];
    },
  },
  methods: {
    updateTruncate() {
      if (!this.isSummaryMode) {
        return;
      }
      const container = this.$refs.container;
      const selector = ".field-set:not(.type-text)";
      const fieldLabelSelector = ".field-label";
      const fieldValueSelector = ".field-value";

      this.$nextTick(() => {
        DOMUtils.elOf(container, selector).forEach((element, index) => {
          let fieldLabel = DOMUtils.elOf(element, fieldLabelSelector)[0];
          let fieldValue = DOMUtils.elOf(element, fieldValueSelector)[0];
          const contentHeight = fieldLabel.scrollHeight + fieldValue.scrollHeight;
          this.truncated.splice(index, 0, false);
          if (contentHeight >= element.offsetHeight) {
            this.truncated.splice(index, 1, true);
          }
        });
      });
    },
  },
  mounted() {
    this.updateTruncate();
  },
};
